import { render, staticRenderFns } from "./Newsroom.vue?vue&type=template&id=5fcec329&scoped=true&"
import script from "./Newsroom.vue?vue&type=script&lang=js&"
export * from "./Newsroom.vue?vue&type=script&lang=js&"
import style0 from "./Newsroom.vue?vue&type=style&index=0&id=5fcec329&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fcec329",
  null
  
)

export default component.exports